var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhereWeFlyLogo = function SvgWhereWeFlyLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#305269"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#305269",
    d: "M12 .186 23.314 11.5 12 22.814.686 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m14.828 18.1.943-.943-1.65-6.364L16.714 8.2a1 1 0 0 0 0-1.414 1 1 0 0 0-1.414 0l-2.593 2.593-6.364-1.65-.943.943 5.186 2.828-2.593 2.593-1.886-.472-.707.707 2.357 1.415L9.172 18.1l.707-.707-.472-1.886L12 12.914z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 .186 23.314 11.5 12 22.814.686 11.5z"
  })))));
};
export default SvgWhereWeFlyLogo;